<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData" add @add="addNew"></Filter>
    <Table :tableData="tableDataList" :total="data.total" :select="false" @update="updatePage">
      <el-table-column type="index" align="center" :label="$t('pages.indexNo')" width="60px" />
      <el-table-column prop="subject" :label="$t('system.emailnotice.notificationName')" />
      <el-table-column prop="senderName" :label="$t('system.emaillist.sender')" />
      <el-table-column prop="fromEmail" :label="$t('system.emailnotice.senderEmail')"/>
      <el-table-column prop="toEmail" :label="$t('system.emaillist.receiverEmail')" />
      <el-table-column prop="robotStatus" :label="$t('system.emailnotice.robotStatus')">
        <template #default="{row}">
          {{ row.robotStatus?.map(status => data.robotStatusMap[status]).join(", ") }}
        </template>
      </el-table-column>
      <el-table-column prop="errorCodeList" :label="$t('system.emailnotice.errorCode')">
        <template #default="{row}">
          {{ row.errorCodeList?.join() }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('system.emaillist.creationTime')" />
      <el-table-column :label="$t('system.emaillist.operation')" fixed="right" width="220">
        <template #default="{row}" style="padding-bottom: 20px;">
          <el-button type="text" size="mini" @click="jumpList(row)">{{$t('system.emailnotice.emailList')}}</el-button>
          <el-button type="text" size="mini" @click="sendTestDetail(row)">{{$t('system.emailnotice.testSending')}}</el-button>
          <el-button type="text" size="mini" @click="editDetail(row)">{{$t('system.emailnotice.edit')}}</el-button>
          <el-button type="text" style="color: #f56c6c;" size="mini" @click="deleteDetail(row)">{{$t('system.emaillist.delete')}}</el-button>
        </template>
      </el-table-column>
    </Table>
    <el-dialog v-model="data.dialogFormVisible" :title="data.dialogTitle" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="detailformRef" class="dialog-form" :model="detailform" :rules="detailformRules" :label-width="curLang == 'zh-CN' ? '120px' : curLang == 'en-US' ? '150px' : '150px'">
        <div class="desc_title">{{$t('system.emailnotice.accountConfiguration')}}</div>
        <el-form-item :label="$t('system.emailnotice.notificationName')" prop="subject">
          <el-input v-model="detailform.subject" :placeholder="$t('system.emailnotice.notificationName')" />
        </el-form-item>
        <el-form-item :label="$t('system.emailnotice.senderEmail')" prop="fromEmail">
          <el-input v-model="detailform.fromEmail" :placeholder="$t('system.emailnotice.senderEmail')" />
        </el-form-item>
        <el-form-item :label="$t('system.emaillist.sender')" prop="senderName">
          <el-input v-model="detailform.senderName" :placeholder="$t('system.emaillist.sender')" />
        </el-form-item>
        <el-form-item :label="$t('system.emailnotice.otaDomain')" prop="otaDomain">
          <el-input v-model="detailform.otaDomain" :placeholder="$t('system.emailnotice.otaDomain')" />
        </el-form-item>
        <el-form-item :label="$t('system.emailnotice.smtpServer')" prop="smtpServer">
          <el-input v-model="detailform.smtpServer" :placeholder="$t('system.emailnotice.smtpServer')" />
        </el-form-item>
        <el-form-item :label="$t('system.emailnotice.smtpPort')" prop="smtpPort">
          <el-input-number
            v-model="detailform.smtpPort"
            :controls="false"
            style="width: 100%;"
            :placeholder="$t('system.emailnotice.smtpPort')"
          />
          <!-- <el-input-number v-model="detailform.smtpPort" placeholder="smtp端口号" /> -->
        </el-form-item>
        <!-- <el-form-item label="是否需要验证" prop="phoneNumber">
          <el-radio-group v-model="detailform.phoneNumber">
            <el-radio :label="3">需要</el-radio>
            <el-radio :label="6">不需要</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item :label="$t('system.emailnotice.smtpAccount')" prop="smtpUser">
          <el-input v-model="detailform.smtpUser" :placeholder="$t('system.emailnotice.smtpAccount')" />
        </el-form-item>
        <el-form-item :label="$t('system.emailnotice.smtpPassword')" prop="smtpPassword">
          <el-input v-model="detailform.smtpPassword" :placeholder="$t('system.emailnotice.smtpPassword')" show-password/>
        </el-form-item>

        <div class="desc_title">{{$t('system.emailnotice.policyConfiguration')}}</div>
        <el-form-item :label="$t('system.emaillist.receiverEmail')" prop="toEmail">
          <el-input v-model="detailform.toEmail" :placeholder="$t('system.emaillist.receiverEmail')" />
        </el-form-item>
        <el-form-item :label="$t('system.emailnotice.robotStatus')" prop="robotStatus">
          <el-checkbox-group v-model="detailform.robotStatus">
            <el-checkbox :disabled="item.id !== 5" v-for="item in data.statusList" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
            <!-- <el-checkbox :label="5">离线</el-checkbox>
            <el-checkbox  :label="2">暂停</el-checkbox>
            <el-checkbox disabled="true" :label="3">故障</el-checkbox>
            <el-checkbox disabled="true" :label="4">报警</el-checkbox>
            <el-checkbox disabled="true" :label="6">空闲</el-checkbox> -->
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('system.emailnotice.errorCode2')" prop="errorCodeList">
          <el-select
            v-model="detailform.errorCodeList"
            :remote-method="getErrorCodeData"
            multiple
            clearable
            filterable
            :placeholder="$t('system.emailnotice.selectErrorCode')"
            remote
            @clear="getRobotData"
          >
            <el-option
              v-for="item in data.errorCodeListData"
              :key="item.errorCode"
              :label="`${item.errorCode} ${item.errorMessageCn}`"
              :value="item.errorCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('system.emailnotice.robot')" prop="robotList">
          <el-select
            v-model="detailform.robotList"
            :remote-method="getRobotData"
            multiple
            clearable
            filterable
            :placeholder="$t('system.emailnotice.selectRobot')"
            remote
            @clear="getRobotData"
          >
            <el-option
              v-for="item in data.robotListData"
              :key="item.robotId"
              :label="item.robotId"
              :value="item.robotId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('system.emaillist.sendingTime')" prop="allowableTimeRange">
          <el-time-picker
            is-range
            v-model="detailform.allowableTimeRange"
            :range-separator="$t('system.emaillist.to')"
            :start-placeholder="$t('system.emaillist.startDate')"
            :end-placeholder="$t('system.emaillist.endDate')"
            value-format="HH:mm:ss"
            :placeholder="$t('system.emaillist.sendingTime')">
          </el-time-picker>
          <!-- <el-date-picker
            v-model="detailform.allowableTimeRange"
            type="datetimerange"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('system.emaillist.sendingTime')"
          /> -->
          <!-- :disabled-date="disabledDate" -->
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" type="primary" @click="editDetailSubmit">{{$t('system.emailnotice.confirm')}}</el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="data.dialogToEmailFormVisible" :title="data.dialogToEmailTitle" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="emailformRef" class="dialog-form" :model="detailform" :rules="emailformRules" label-width="120px">
        <el-form-item :label="$t('system.emailnotice.testReceiverEmail')" prop="toEmail">
          <el-input v-model="detailform.toEmail" :placeholder="$t('system.emailnotice.testReceiverEmail')" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" type="primary" @click="sendTestSubmit">{{$t('system.emailnotice.confirm')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "@/common/mixin";
import { ref, reactive, computed } from "@vue/reactivity";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { ElMessage, ElMessageBox } from "element-plus";
import { reqDeleteEmailConfig } from "@/api/robot"
import { robotStatusMap, statusList } from "@/common/constant"
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useStore } from "vuex"

export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const store = useStore()
    const { t } = useI18n()
    const router = useRouter()
    const params = [
      {
        key: "subject",
        value: "",
        label: t('system.emailnotice.notificationName'),
      },
      {
        key: "senderName",
        value: "",
        label: t('system.emaillist.sender'),
      },
      {
        key: "fromEmail",
        value: "",
        label: t('system.emailnotice.senderEmail'),
      },
      {
        key: "toEmail",
        value: "",
        label: t('system.emaillist.receiverEmail'),
      },
      {
        type: "Date",
        key: "dateRange",
        value: [],
        label: t('system.emailnotice.creationDate'),
        options: {
          "type": "datetimerange",
          "format": "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "range-separator": t('system.emaillist.to'),
          "start-placeholder": t('system.emaillist.startDate'),
          "end-placeholder": t('system.emaillist.endDate'),
          "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
        }
      }
    ];
    var query = {
      userName: "", // 姓名
      phoneNumber: "", // 电话
      robotId: "", // 机器人编码
    };
    const data = reactive({
      dialogFormVisible: false,
      dialogTitle: '',
      dialogTableVisible: false,
      page: 1,
      size: 10,
      total: 0,
      robotListData: [],
      errorCodeListData: [],
      robotStatusMap: robotStatusMap,
      statusList: statusList,
      dialogToEmailFormVisible: false,
      dialogToEmailTitle: ''
    });
    const curLang = computed(() => store.state.lang)
    const tableDataList = ref([]);
    const detailform = reactive({
        id: '',
        subject: "",
        fromEmail: "",
        senderName: "",
        otaDomain: "",
        smtpServer: "",
        smtpPort: "",
        smtpUser: "",
        smtpPassword: "",
        toEmail: "",
        robotStatus: [],
        errorCodeList: [],
        robotList: [],
        allowableTimeRange: []

    })
    const emailformRef = ref(null)
    const emailformRules = reactive({
      toEmail: {
        required: true,
        message: t('system.emailnotice.enterReceiverEmail'),
        trigger: 'change',
      }
    })
    const detailformRef = ref(null)
    const detailformRules = reactive({
      subject: {
        required: true,
        message: t('system.emailnotice.enterNotificationName'),
        trigger: 'blur',
      },
      fromEmail: {
        required: true,
        message: t('system.emailnotice.enterSenderEmail'),
        trigger: 'blur',
      },
      senderName: {
        required: true,
        message: t('system.emailnotice.enterSender'),
        trigger: 'change',
      },
      otaDomain: {
        required: true,
        message: t('system.emailnotice.enterOtaDomain'),
        trigger: 'change',
      },
      smtpServer: {
        required: true,
        message: t('system.emailnotice.enterSmtpServer'),
        trigger: 'change',
      },
      smtpPort: {
        required: true,
        message: t('system.emailnotice.enterSmtpPort'),
        trigger: 'change',
      },
      smtpUser: {
        required: true,
        message: t('system.emailnotice.enterSmtpAccount'),
        trigger: 'change',
      },
      smtpPassword: {
        required: true,
        message: t('system.emailnotice.enterSmtpPassword'),
        trigger: 'change',
      },
      toEmail: {
        required: true,
        message: t('system.emailnotice.enterReceiverEmail'),
        trigger: 'change',
      },
      robotList: {
        required: true,
        message: t('system.emailnotice.selectRobot'),
        trigger: 'change',
      },
      allowableTimeRange: {
        required: true,
        message: t('system.emaillist.sendingTime'),
        trigger: 'change',
      }
    })
    const getRobotData = async (name) => {
      try {
        const res = await request('getRobotList', {
          page: 1,
          size: 20,
          robotId: name,
        })
        data.robotListData = (res.records || []).slice(0, 20)
      } catch (error) {
        console.error(error)
      }
    }
    const getErrorCodeData = async (name) => {
      try {
        const res = await request('errorCodeList', {
          page: 1,
          size: 20,
          filter: name,
        })
        data.errorCodeListData = (res || []).slice(0, 20)
      } catch (error) {
        console.error(error)
      }
    }
    const getData = async () => {
      console.log("query", query);
      try {
        const res = await request("requestEmailList", {
          ...query,
          startTime: query.dateRange?.[0],
          endTime: query.dateRange?.[1],
          page: data.page,
          size: data.size,
        });
        console.log("requestList", res);
        tableDataList.value = res.records;
        data.total = res.total;
      } catch (error) {
        console.error(error);
      }
    };
    const searchData = (data) => {
      query = data;
      getData();
    };
    const updatePage = (page, size) => {
      data.page = page || 1;
      data.size = size || 10;
      getData();
    };
    const jumpList = async (row) => {
      try {
        router.push({ path: '/system/emailList',  query: { id: row.id } })
      } catch (error) {
        console.error(error);
      }
    }
    const sendTestDetail = async (row) => {
      try {
        detailform.toEmail = row.toEmail
        detailform.id = row.id
        data.dialogTitle = t('system.emailnotice.testSending')
        data.dialogToEmailFormVisible = true
      } catch (error) {
        console.error(error);
      }
    }
    const deleteDetail = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('system.emaillist.confirmDelete'),
          {
            confirmButtonText: t('system.emaillist.confirm'),
            cancelButtonText: t('system.emaillist.cancel'),
            type: 'warning',
          }
        )
        await reqDeleteEmailConfig(row.id)
        ElMessage({
          showClose: true,
          type: "success",
          message: t('system.emaillist.deleteSuccess')
        })
        getData()
      } catch (error) {
        console.error(error)
      }
    }
    const editDetail = async (row) => {
      try {
        for (let key of Object.keys(detailform)) {
          if (row[key]) {
            detailform[key] = row[key];
          } else {
            detailform[key] = "";
          }
        }
        data.dialogTitle = t('system.emailnotice.editEmailNotification')
        detailform.id = row.id
        data.dialogFormVisible = true
        getRobotData()
        getErrorCodeData()
        console.log("editDetail", row);
      } catch (error) {
        console.error(error);
      }
    }
    const editDetailSubmit = async () => {
      console.log('editDetailSubmit', detailform)
      try {
        detailformRef.value && await detailformRef.value.validate()
        // if (detailform.id) {
          await request("updateEmailConfig", {
            ...detailform
          })
          getData()
          ElMessage({
            showClose: true,
            type: "success",
            message: t('system.emailnotice.submitSuccess')
          })
        // } else {
        //   applyList.push({
        //     phoneNumber: detailform.phoneNumber,
        //     robotId: detailform.robotId,
        //     startTime: detailform.startTime,
        //     endTime: detailform.endTime
        //   })
        //   // await request("permissionRequest", detailform)
        // }
        data.dialogFormVisible = false
      } catch (error) {
        console.error(error)
      }
    }
    const sendTestSubmit = async () => {
      console.log('sendTestSubmit', detailform)
      try {
        emailformRef.value && await emailformRef.value.validate()
        const res = await request("sendTest", {
          toEmail: detailform.toEmail,
          emailConfigId: detailform.id,
        });
        console.log("requestList", res);
        data.dialogToEmailFormVisible = false
        getData()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('system.emailnotice.testEmailSentSuccess')
        })
        data.dialogFormVisible = false
      } catch (error) {
        console.error(error)
      }
    }
    const handleDetail = async (row) => {
      try {
        console.log('handleDetail', row)
        await request("addPermission", {
          id: row.id
        })
        ElMessage({
          showClose: true,
          type: "success",
          message: t('system.emailnotice.approvalSuccess'),
        });
        getData();
      } catch (error) {
        console.error(error);
      }
    };
    const selectHandle = async (val) => {
      try {
        console.log('selectHandle', val)
        const params = val.map((item => {
          return { id: item.id}
        }))
        console.log(params)
        await request("addPermissionBatch", params)
        ElMessage({
          showClose: true,
          type: "success",
          message: t('system.emailnotice.approvalSuccess'),
        });
        getData();
      } catch (error) {
        console.error(error);
      }
    }
    const addNew = () => {
      // data.dialogTableVisible = true
      data.dialogFormVisible = true
      data.dialogTitle = t('system.emaillist.addEmailNotification')
      for (let key of Object.keys(detailform)) {
        detailform[key] = ""
        if(['robotStatus', 'errorCodeList', 'robotList'].includes(key)){
          detailform[key] = []
        }
      }
    }

    const disabledDate = function(time) {
      return time.getTime() < (Date.now() - 86400000)
    }
   
    getData();
    return {
      params,
      query,
      data,
      tableDataList,
      detailform,
      detailformRef,
      emailformRef,
      emailformRules,
      detailformRules,
      getRobotData,
      getErrorCodeData,
      getData,
      searchData,
      updatePage,
      jumpList,
      sendTestDetail,
      deleteDetail,
      editDetail,
      editDetailSubmit,
      sendTestSubmit,
      handleDetail,
      selectHandle,
      addNew,
      disabledDate,
      curLang
    };
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.desc_title{
  position: relative;
  padding-left: 12px;
  margin-bottom: 20px;
  font-size: 18px;
  color: #1677ff;
}
.desc_title::before{
  position: absolute;
  content: ' ';
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: #1677ff;
}
:deep(.el-input-number .el-input__inner) {
  text-align: left;
}
</style>
